// CRB11: an emailed destination carries opaque report IDs only. Normal sign-in and API checks remain required.
const UUID = /^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/i;
export interface ReportArrival { definitionId:string; version:number }
export function reportArrival(tier:"tenant"|"network"|"platform",tenantId?:string,consume=false):ReportArrival|undefined {
  const query = new URLSearchParams(window.location.search);
  const definitionId = query.get("report_definition");const rawVersion = query.get("report_version");
  if(definitionId === null || !UUID.test(definitionId) || rawVersion === null || !/^[1-9]\d{0,8}$/.test(rawVersion))return undefined;
  const version = Number(rawVersion);
  if(!Number.isSafeInteger(version))return undefined;
  if(tier === "tenant" && (tenantId === undefined || query.get("report_tenant") !== tenantId))return undefined;
  if((tier === "network" || tier === "platform") && query.has("report_tenant"))return undefined;
  if(consume) {
    query.delete("report_definition");query.delete("report_version");query.delete("report_tenant");
    const search = query.toString();
    window.history.replaceState(window.history.state,"",`${window.location.pathname}${search.length === 0 ? "" : `?${search}`}${window.location.hash}`);
  }
  return {definitionId,version};
}
